const $ = require('jquery');

const $body = $('body'),
    $searchBar = $('.masthead__search'),
    $searchInput = $searchBar.find('input[type="search"]');

// toggle-search
$('#toggle-search').on('click', function(e) {
    e.preventDefault();
    if ($body.hasClass('show-search')) {
        $searchInput.blur();
        $body.removeClass('show-search');
    } else {
        $body.addClass('show-search');
        setTimeout(function() {
            $searchInput.focus();
        }, 100);
    }
});